/* eslint-disable import/no-extraneous-dependencies */
import { AntDesign } from '@expo/vector-icons';
import React from 'react';
import ImageViewer from 'react-native-image-zoom-viewer';
import { IImageInfo } from 'react-native-image-zoom-viewer/built/image-viewer.type';
import ReactNativeModal from 'react-native-modal';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import { IconButton } from '../buttons';

export const ImageViewerModal = ({
  isVisible,
  index,
  images,
  onClose,
}: {
  isVisible: boolean;
  index?: number;
  images: IImageInfo[];
  onClose: () => void;
}) => {
  return (
    <ReactNativeModal isVisible={isVisible} style={{ margin: 0 }}>
      <ImageViewer index={index} imageUrls={images} />
      <IconButton
        style={{ position: 'absolute', top: metrics.huge, left: metrics.huge }}
        icon={<AntDesign name="closecircle" size={pixelScaler(30)} color={AppColors.white} />}
        onPress={onClose}
      />
    </ReactNativeModal>
  );
};
